import { render } from "./CreateNewUserForm.vue?vue&type=template&id=abfa4a3a&scoped=true"
import script from "./CreateNewUserForm.vue?vue&type=script&lang=js"
export * from "./CreateNewUserForm.vue?vue&type=script&lang=js"

import "./CreateNewUserForm.vue?vue&type=style&index=0&id=abfa4a3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abfa4a3a"]])

export default __exports__